// @flow

import { DraftLiveStateEnum } from "@modules/service/constants";
import type { RtwStateType } from "./types";

export const initialState: RtwStateType = {
  requestsInProgress: 0,
  schema: null,
  liveProcesses: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },
  liveProcessesFilter: null,

  pendingProcesses: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },

  draftProcesses: {
    content: [],
    pagination: {
      offset: 0,
      pageNumber: 0,
      pageSize: 0,
    },
    totalElements: 0,
  },

  current: null,
  draft: null,
  assignments: [],
  draftAssignments: [],
  configuration: {
    enabled: true,
    status: DraftLiveStateEnum.LIVE,
  },
  modals: {
    modalStep: 1,
    showAddModal: false,
    showEditModal: false,
    showEditAssignmentsModal: false,
    showDiscardModal: false,
    showSubmitModal: false,
    showCancelModal: false,
    showCancelDiscardModal: false,
    showDisableModal: false,
    showAddRtwAttachmentModal: false,
  },
  addFileInProgress: false,
};

export default initialState;
